import React from "react";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import fiLocale from "date-fns/locale/fi";
import format from "date-fns/format";
import { DatePicker as MuiDatePicker, DatePickerProps as MuiDatePickerProps } from "formik-material-ui-pickers";
import { Field, FieldProps } from "formik";

class FiLocalizedUtils extends DateFnsUtils {
  getCalendarHeaderText(date: Date) {
    return format(date, "LLLL", { locale: fiLocale });
  }

  getDatePickerHeaderText(date: Date) {
    return format(date, "d. MMMM", { locale: fiLocale });
  }
}

interface DatePickerProps {
  name: string;
}
const DatePicker = (props: DatePickerProps & Partial<MuiDatePickerProps> & Partial<FieldProps>): JSX.Element => {
  return (
    <MuiPickersUtilsProvider utils={FiLocalizedUtils} locale={fiLocale}>
      <Field component={MuiDatePicker} format="dd.MM.yyyy" autoOk fullWidth variant="inline" {...props} />
    </MuiPickersUtilsProvider>
  );
};

export default DatePicker;
